import "regenerator-runtime/runtime";
import _asyncToGenerator from "D:/mzkj/\u8981\u70BC/yl-pc-business/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var imgUrl = require('@/assets/image/noPass.png');

export default {
  data: function data() {
    return {
      imgUrl: imgUrl,
      subTitle: '原因：您上传的资质不清晰，请修改后重新提交申请',
      title: '入驻审核未通过'
    };
  },
  mounted: function mounted() {
    this.dataBind();
  },
  methods: {
    dataBind: function dataBind() {
      var _this = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var _yield$_this$$api$che, rejectReason;

        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return _this.$api.checkTokenStatus();

              case 2:
                _yield$_this$$api$che = _context.sent;
                rejectReason = _yield$_this$$api$che.rejectReason;
                _this.subTitle = '原因：' + rejectReason;

              case 5:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }))();
    }
  }
};